/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairAlternativeOffers } from '../../models/finnair-alternative-offers';

export interface DisruptionAlternativeOffersV2$Params {
  orderId: string;
  locale?: string;
  hash?: string;
  boundId?: string;
  searchDate?: string;
}

export function disruptionAlternativeOffersV2(http: HttpClient, rootUrl: string, params: DisruptionAlternativeOffersV2$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairAlternativeOffers>> {
  const rb = new DapiRequestBuilder(rootUrl, disruptionAlternativeOffersV2.PATH, 'get');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.query('boundId', params.boundId, {});
    rb.query('searchDate', params.searchDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairAlternativeOffers>;
    }),
    catchErrorAsJson()
  );
}

disruptionAlternativeOffersV2.PATH = '/api/v2/offer/{orderId}/disruption-rebooking/alternatives';
